var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.errors.collect(_vm.question.id), function(error) {
        return _c("p", { key: error, staticClass: "errorText" }, [
          _vm._v("\n        " + _vm._s(error) + "\n    ")
        ])
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.itemValue.value,
            expression: "itemValue.value"
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: {
              rules: {
                required: _vm.question.required,
                email: true,
                free_email: [_vm.origEmail]
              }
            },
            expression:
              "{rules: {'required': question.required, 'email': true, 'free_email': [origEmail]}}"
          }
        ],
        class: { error: _vm.errors.has(_vm.question.id) },
        attrs: {
          type: "text",
          "data-vv-delay": "200",
          name: _vm.question.id,
          id: _vm.question.id
        },
        domProps: { value: _vm.itemValue.value },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.itemValue.value = $event.target.value
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d46f975", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d46f975","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileEmailEditor.vue
// module id = 559
// module chunks = 2